var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word-cloud"},[_c('vue-word-cloud',{attrs:{"words":_vm.chapters,"color":function (ref) {
	var weight = ref[1];

	return weight > 50 ? 'DeepPink' : weight > 25 ? 'RoyalBlue' : 'Indigo';
},"font-family":"Roboto"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ba1ec6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WordCloud.vue
// module id = 2840
// module chunks = 1